// src/utils/instagramAuth.js

// TODO: Replace with your actual App ID from Meta Developers
export const INSTAGRAM_APP_ID = "1491859291902509";

// TODO: Ensure this matches exactly what is in your Meta App settings
// For local testing: http://localhost:3000/auth/instagram/callback
export const REDIRECT_URI = `http://localhost:3000/auth/instagram/callback`;

export const getInstagramAuthUrl = () => {
    // Using Instagram endpoint to match the requested UI
    // Ensure "Instagram Graph API" is added in Meta Dashboard
    const rootUrl = "https://www.instagram.com/oauth/authorize";
    const options = {
        client_id: INSTAGRAM_APP_ID,
        redirect_uri: REDIRECT_URI,
        // Scopes required for reading Instagram profile, media, and insights
        scope: "instagram_business_basic,instagram_manage_insights,pages_show_list,pages_read_engagement",
        response_type: "code",
        state: "inst_connect", // Optional: use for CSRF protection
    };

    const qs = new URLSearchParams(options).toString();
    return `${rootUrl}?${qs}`;
};

export const exchangeInstagramCode = async (code) => {
    // This function SHOULD call your backend
    // DO NOT expose client_secret here

    console.log("Exchanging code:", code);

    // Simulation for frontend-only flow
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                success: true,
                message: "Code received. Backend exchange pending.",
                code: code
            });
        }, 1000);
    });
};
